import * as actionTypes from './types';
import { request } from '@/request';
import cryptoHelpers from '@/utils/cryptoGraphy';
export const erp = {
  resetState: () => (dispatch) => {
    dispatch({
      type: actionTypes.RESET_STATE,
    });
  },
  resetAction:
    ({ actionType }) =>
      (dispatch) => {
        dispatch({
          type: actionTypes.RESET_ACTION,
          keyState: actionType,
          payload: null,
        });
      },
  currentItem:
    ({ data }) =>
      (dispatch) => {
        dispatch({
          type: actionTypes.CURRENT_ITEM,
          payload: { ...data }, // Ensure this is a valid object for your state
        });
      },
  currentAction:
    ({ actionType, data }) =>
      (dispatch) => {
        dispatch({
          type: actionTypes.CURRENT_ACTION,
          keyState: actionType,
          payload: { ...data }, // Ensure this is a valid object for your state
        });
      },
  list:
    ({ entity, options = { page: 1, items: 10 } }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'list',
          payload: null,
        });

        let data = await request.list({ entity, options });

        if (data.success === true) {
          const decryptedData = cryptoHelpers.decrypt(data.result);
          const result = {
            items: decryptedData, // Ensure this is a valid array or object for rendering
            pagination: {
              current: parseInt(data.pagination.page, 10),
              pageSize: options?.items || 10,
              total: parseInt(data.pagination.count, 10),
            },
          };
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'list',
            payload: result,
          });
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'list',
            payload: null,
          });
        }
      },
  create:
    ({ entity, jsonData }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'create',
          payload: null,
        });

        let data = await request.create({ entity, jsonData });

        if (data.success === true) {
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'create',
            payload: data.result,
          });
          dispatch({
            type: actionTypes.CURRENT_ITEM,
            payload: data.result, // Ensure data.result is structured properly for your state
          });
          return true;
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'create',
            payload: null,
          });
          return false;
        }
      },

  read:
    ({ entity, id }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'read',
          payload: null,
        });

        let data = await request.read({ entity, id });

        if (data.success === true) {
          dispatch({
            type: actionTypes.CURRENT_ITEM,
            payload: data.result, // Ensure data.result is handled properly
          });
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'read',
            payload: data.result,
          });
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'read',
            payload: null,
          });
        }
      },
  update:
    ({ entity, id, jsonData }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'update',
          payload: null,
        });

        let data = await request.update({ entity, id, jsonData });

        if (data.success === true) {
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'update',
            payload: data.result,
          });
          dispatch({
            type: actionTypes.CURRENT_ITEM,
            payload: data.result, // Ensure data.result is valid for your components
          });
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'update',
            payload: null,
          });
        }
      },

  delete:
    ({ entity, id }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.RESET_ACTION,
          keyState: 'delete',
        });
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'delete',
          payload: null,
        });

        let data = await request.delete({ entity, id });

        if (data.success === true) {
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'delete',
            payload: data.result, // Ensure this is structured properly
          });
          dispatch({
            type: actionTypes.RESET_ACTION,
            keyState: 'delete',
          });
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'delete',
            payload: null,
          });
        }
      },

  search:
    ({ entity, options }) =>
      async (dispatch) => {
        dispatch({
          type: actionTypes.REQUEST_LOADING,
          keyState: 'search',
          payload: null,
        });

        let data = await request.search({ entity, options });

        if (data.success === true) {
          dispatch({
            type: actionTypes.REQUEST_SUCCESS,
            keyState: 'search',
            payload: data.result, // Ensure this is an appropriate data structure
          });
        } else {
          dispatch({
            type: actionTypes.REQUEST_FAILED,
            keyState: 'search',
            payload: null,
          });
        }
      },
};
